module.exports = __webpack_public_path__ + "img/footer-bg-2.e1849532.png";